export const getQuestionKey = (question, index) => String(question?.id ?? `legacy-${index}`);
export const optionId = (option) => String(option?.id ?? option?.text ?? '');
export const isFilterableQuestion = (question) => question?.type !== 'text' && Array.isArray(question?.options) && question.options.length > 0;
export const applyPollFilters = (poll, users, filters = {}) => users.filter((user) => {
  const age = filters.age;
  if (age != null && Number(user.ageType ?? user.registration?.ageType) !== Number(age)) return false;
  if (filters.payment && user.paymentStatus !== filters.payment) return false;
  return (poll.questions || []).every((question, index) => {
    const selected = filters.answers?.[getQuestionKey(question, index)];
    if (!selected) return true;
    const response = user.responses?.find((item) => String(item.questionId) === String(question.id))?.response;
    return (Array.isArray(response) ? response : [response]).map(String).includes(String(selected));
  });
});
